import React, { useState } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import BackArrow from "../../Components/BackArrow/BackArrow";
import Search from "../../Components/Search/Search";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import ColorsTable from "../../Components/Table/ColorsTable";
import CreateModal from "../../Components/Modals/CreateColor";
import modalImg from "../../Assets/Images/color.png";

const Colors = () => {
  // modal
  const [modalShow, setModalShow] = useState(false);
  // search
  const [search, setSearch] = useState("");
  return (
    <div>
      <Navigation />
      <div className="colors-Main">
        <BackArrow to="/breeds" />
        <div className="colors-Div">
          <h3>Colors</h3>
          <div className="search-modal">
            <Search SearchValFuc={setSearch} SearchValue={search} />
            <button
              className="create"
              variant="primary"
              onClick={() => {
                setModalShow(true);
              }}
            >
              + ADD COLORS
            </button>
          </div>
          <SearchBarResults SearchValue={search} />
        </div>
        <ColorsTable SearchValue={search} />
      </div>
      <CreateModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        head="Add a new color"
        detail="You can add the new color here"
        placeholder="Enter color"
        images={modalImg}
      />
    </div>
  );
};

export default Colors;
